import React from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from '@material-ui/core'

import { ReactComponent as AccordionArrow } from 'presentation/assets/icons/accordion-arrow.svg'
import CardNew from '../CardNew'
// import * as S from './styles'

type AccordionProps = {
  accordionLabel: string
  header: React.ReactElement | string
  content: React.ReactElement | string
  defaultExpanded?: boolean
  expanded?: boolean // Optional for open one and close the others accordions
  handleChange?: (accordionLabel: string, isExpanded: boolean) => void // Optional for open one and close the others accordions
  disabled?: boolean
  expandIcon?: React.ReactElement
  padding?: string
}

const AccordionCard = ({
  accordionLabel = 'panel',
  header,
  content,
  defaultExpanded = false,
  expanded,
  handleChange,
  disabled = false,
  expandIcon,
  padding = '0'
}: AccordionProps) => {
  return (
    <CardNew shadow="medium" border="style2" padding={padding}>
      <Accordion
        defaultExpanded={defaultExpanded}
        expanded={expanded}
        onChange={(e, expanded) =>
          !!handleChange && handleChange(accordionLabel, expanded)
        }
        disabled={disabled}
      >
        <AccordionSummary
          expandIcon={expandIcon ? expandIcon : <AccordionArrow />}
          id={`${accordionLabel}-header`}
          aria-controls={`${accordionLabel}-content`}
        >
          {header}
        </AccordionSummary>
        <AccordionDetails>{content}</AccordionDetails>
      </Accordion>
    </CardNew>
  )
}

export default AccordionCard
